<template>
	<div class="product">
        <div class="product-dev" v-if="showDev"> 
            <button v-if="! editing && ! newing" @click="toggleEditing" class="edit-button"> edit </button>
            <div v-else class="editing-buttons"> 
                <button :disabled=" newing" @click="stornoEdit"> Zahodit </button>
                <button @click="saveEdit"> Save </button>
                <button @click="deleteProduct"> Delete </button>
                <button @click="toggleEditing"> x </button>
            </div>

        </div>

        <div v-if="editing || newing" class="product-card-editing"> 
            <input  v-model="editedProduct.spolecnost" placeholder="Spolecnost" class="product-company-input" /> 
            <input  v-model="editedProduct.priorita" placeholder="Prio"/>
            <input  v-model="editedProduct.rychlost" placeholder="Rychlost"/>
            <input  v-model="editedProduct.cena" placeholder="Cena"/>
            <input  v-model="editedProduct.instalace" placeholder="instalace"/>
            <span> Zobrazovat: 
                <input type="checkbox" v-model="editedProduct.show"/>
            </span>

            <input  v-model="editedProduct.bonusy" placeholder="Bonusy"/>
            <input v-model="editedProduct.poznamka" placeholder="poznamka"/>
            <div class="hlaska" v-for="hlaska of chybneHlasky" :key="hlaska"> {{ hlaska }} </div> 
        </div> 

        <div v-else class="product-card">
            <div class="product-card-title"> {{ product.spolecnost }} </div>
            <div class="product-card-stats"> Priorita: <span class="stat-gray"> {{ product.priorita }} </span> </div>
            <div class="product-card-stats"> Rychlost: <span class="stat-gray"> {{ product.rychlost }} </span> </div>
            <div class="product-card-stats"> Cena: <span class="stat-gray"> {{ product.cena }} </span> </div>
            <div class="product-card-stats"> Zobrazovat: <span class="stat-gray"> {{ product.show ? 'Ano' : 'Ne'}} </span> </div>
            <div class="product-card-stats"> Bonusy: <span class="stat-gray"> {{ product.bonusy }} </span> </div>
            <div class="product-card-stats"> Poznamka: <span class="stat-gray"> {{ product.poznamka }} </span> </div>
        </div>
	
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'


export default {
	name: 'Product',

	components: {

    },
    
    props: {
        newing: false,
        product: {},
        adresniMisto: null,
    },

	data () {
		return {
            editing: false,
            editedProduct: {},
            showDev: true,
            chybneHlasky: [],
            productAdding: false,
		}
    },
    
    created() {
        this.editedProduct = JSON.parse(JSON.stringify(this.$props.product))
    },	

	methods: {
        async saveEdit () {
            if (this.newing) {
                this.productAdding = true
                this.chybneHlasky = []

                if (! this.editedProduct) {
                    this.chybneHlasky.push('wtf')
                }

                if (! this.editedProduct.hasOwnProperty('cena') || this.editedProduct.cena === '') {
                    this.chybneHlasky.push('Spatna cena')
                } 

                if (! this.editedProduct.hasOwnProperty('spolecnost') || this.editedProduct.spolecnost === '') {
                    this.chybneHlasky.push('Spatna spolecnost')
                } 

                const prio = parseInt(this.editedProduct.priorita) 

				if (! this.editedProduct.hasOwnProperty('priorita') || this.editedProduct.priorita === '' || isNaN(prio)) {
                    this.chybneHlasky.push('Spatna priorita')
				} 
				
                this.editedProduct.priorita = prio

                if (! this.editedProduct.hasOwnProperty('rychlost') || this.editedProduct.rychlost === '' ) {
                    this.chybneHlasky.push('Spatna rychlost')
				}

                if (this.chybneHlasky.length) {
                    return
                }

                const products = await AdditionsService.addNewProduct(this.adresniMisto, this.editedProduct)
				this.productAdding = false
				
                this.$emit('refetch')
				this.$emit('stopCreating')
				
            } else if (this.editing) {
                this.productAdding = true
				this.chybneHlasky = []
				
                if (! this.editedProduct) {
                    this.chybneHlasky.push('wtf')
				}
				
                if (! this.editedProduct.hasOwnProperty('cena') || this.editedProduct.cena === '') {
                    this.chybneHlasky.push('Spatna cena')
				} 
				
                if (! this.editedProduct.hasOwnProperty('spolecnost') || this.editedProduct.spolecnost === '') {
                    this.chybneHlasky.push('Spatna spolecnost')
				} 
				
                const prio = parseInt(this.editedProduct.priorita) 

				if (! this.editedProduct.hasOwnProperty('priorita') || this.editedProduct.priorita === '' || isNaN(prio)) {
                    this.chybneHlasky.push('Spatna priorita')
				} 
				
                this.editedProduct.priorita = prio

                if (! this.editedProduct.hasOwnProperty('rychlost') || this.editedProduct.rychlost === '' ) {
                    this.chybneHlasky.push('Spatna rychlost')
				} 
				
                if (this.chybneHlasky.length) {
                    return
                }

                const products = await AdditionsService.updateProduct(this.editedProduct)
                this.productAdding = false

                this.$emit('refetch')
            }
        },

        async deleteProduct () {
            await AdditionsService.deleteProduct(this.product.index)
            this.$emit('refetch')
        },

        stornoEdit () {
            this.editedProduct = this.$props.product
        },

		toggleEditing () {
            if (this.newing) {
                this.editing = false
                this.$emit('stopCreating')
                return
            }

            if (! this.editing) {
                const holdProduct = JSON.parse(JSON.stringify(this.$props.product))
                this.editedProduct = holdProduct
            }

            this.editing = ! this.editing
        },
	},
}

// TODO css stylus omg
</script>

<style scoped>
.product {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
	margin-top: 10px;
}
.product-dev {
    width: 200px;
    height: 40px;
}

.editing-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 40px;
}

.product-card {
	width: 200px;
	height: 243px;
	background-color: white;
    display: flex;
	flex-direction: column;
    text-align: left;
    padding-top: 5px;
    padding-left: 5px;
}

.product-card-editing {
	width: 200px;
	height: 243px;
	background-color: white;
	display: flex;
	flex-direction: column;
}

.edit-button {
    width: 100%;
    height: 40px;
}

.hlaska {
	font-size: 14px;
	color: red;
	height: 15px;
	margin-top: 0px;
	/* background-color: blue; */
	padding-top: 0px;
	line-height: 15px;
}

.product-company-input {
	height: 40px;
	padding-left: 5px;

}
/* @media (max-width: 1000px) {


} */

</style>



// WEBPACK FOOTER //
// src/components/verifier/Product.vue